import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgencyTypeModel } from 'src/app/Model/AgencyType.model';
import { AggregatorModel } from 'src/app/Model/Aggregator.model';
import { ContactTypeModel } from 'src/app/Model/ContactType.model';
import { CountryModel } from 'src/app/Model/Country.model';
import { DocumentTypeModel } from 'src/app/Model/DocumentType.model';
import { FillerNavItem } from 'src/app/Model/FillerNavItem.model';
import { ParametersModel } from 'src/app/Model/Parameter.model';
import { RegionModel } from 'src/app/Model/Region.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RolesArdModel } from 'src/app/Model/RolesArd.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { EthicsComplianceService } from 'src/app/Services/EthicsCompliance/ethics-compliance.service';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { ComService } from 'src/app/Services/com-service/com.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { RequestService } from 'src/app/Services/request/request.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { LearnmoreFormDataComponent } from '../learnmore-form-data/learnmore-form-data.component';
import { FormSectionsService } from 'src/app/Services/FormSections/form-sections.service';
import { Sections } from 'src/app/Model/Enums/Sections.enum';
import { AgencyTypes } from 'src/app/Model/Enums/AgencyType.enums';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  public lstDocTypes: DocumentTypeModel[];
  public activeLang = 'es';
  crmPreApproval: boolean;
  request: RequestModel = new RequestModel();
  lstAggregators: AggregatorModel[];
  lstDocumentTypes: DocumentTypeModel[];
  
  lstRegions: RegionModel[];
  lstContactTypes: ContactTypeModel[];
  lstRolesArd: RolesArdModel[];
  lstAgencyTypes: AgencyTypeModel[];
  lstCountries: CountryModel[];
  lstLanguages: ParametersModel[];
  lstStatuses: VRequestStatusProcessModel[]=[];
  idRequest: number;
  fillerNav: { label: string; icon: string; link: string; }[];
  validEthicsCompliance: boolean
  validAccessLetter: boolean
  lang: string;
  updateIdentificationCrm :boolean;
  updateLegalCrm: boolean;
  updatePartnersCrm: boolean;
  step = 0;

  @ViewChild('popUp',{static: false})
  popUp: ElementRef;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    //buscar el indice de la sección actual
    
    if (this.request.Id != null && this.request.Id > 0){
      let actualItemIndex = this.itemCreate.findIndex(x => x.link == this.step)
      let actualItem = this.itemCreate[actualItemIndex + 1]
      this.step = actualItem.link
    }
      
    else
      Swal.fire({
        icon: 'warning',
        text: this.translate.instant('Request.Messages.IncompleteOverview'),
        showConfirmButton: false,
        timer: 2000
      })
  }

  prevStep() {
    let actualItemIndex = this.itemCreate.findIndex(x => x.link == this.step)
    let actualItem = this.itemCreate[actualItemIndex - 1]
    this.step = actualItem.link
  }
  async loadCountries() {
    await this.crmGeoService.getCountries().then(res => {
      this.lstCountries = res;
    });
  }
  async loadDocumentTypesCrm(country) {

    await this.crmGeoService.getDocumentTypesCrm(country).then(res => {
      this.lstDocumentTypes = res;
    });
  }
  async loadContactTypes() {
    await this.requestService.getContactTypes().then(res => {
      this.lstContactTypes = res;
    });
  }
  async loadRolesArd(ConnectionType) {
    await this.requestService.getRolesARD().then(res => {
      this.lstRolesArd = res;

      let lang = this.lsService.getLSItem('language')
    
      if (lang == "es") {
        if(ConnectionType != 5){
          this.lstRolesArd = res; 
        }
        else{
          this.lstRolesArd = res.filter(x => x.Name != "Agente"); 
        }
      }

      if (lang == "en") {

        if(ConnectionType != 5){
          this.lstRolesArd = res; 
        }
        else{
          this.lstRolesArd = res.filter(x => x.Name != "Agente"); 
        }
        
        this.lstRolesArd.forEach(element => {
          if (element.Name == "Supervisor") {
            element.Name = "Supervisor"
          }

          if (element.Name == "Agente") {
            element.Name = "Agent"
          }
        });

      }

      if (lang == "pt") {

        if(ConnectionType != 5){
          this.lstRolesArd = res; 
        }
        else{
          this.lstRolesArd = res.filter(x => x.Name != "Agente"); 
        }

        this.lstRolesArd.forEach(element => {
          if (element.Name == "Supervisor") {
            element.Name = "Supervisor"
          }

          if (element.Name == "Agente") {
            element.Name = "Agente"
          }
        });
      }

    });
  }
  async loadAgencyTypes() {
    await this.requestService.getAgencyTypes().then(res => {
      this.lstAgencyTypes = res;
    });
  }
  async loadLanguages() {
    await this.crmGeoService.getLanguage().then(res => {
      this.lstLanguages = res;
    });
  }
  async updateRequest(id) {
    await this.spinner.show()
    this.idRequest = id;
    let rq = await this.requestService.getRequestById(id);
    if (rq != null) {
      this.request = rq;
      if(
        this.request.IsUpdateCrm == true ||
        this.request.IsUpdateCrmLocation == true ||
        this.request.IsNewIata == true
      ){
        this.lsService.setLSItem('redirectPACO', "true")
      }
      //Si no hay tipo de agencia en el local storage, se guarda el tipo de agencia del request
      if(!this.lsService.getLSItem('agencyType') && this.request.AgencyType != undefined){
        this.lsService.setLSItem('agencyType', this.request.AgencyType.toString())
      }
      //Si hay tipo de agencia en el local storage y el tipo de agencia del request es diferente al del local storage, se actualiza el tipo de agencia del local storage
      else if(this.lsService.getLSItem('agencyType') && this.request.AgencyType != undefined){
        if(this.lsService.getLSItem('agencyType') != this.request.AgencyType.toString())
          this.lsService.setLSItem('agencyType', this.request.AgencyType.toString())
      }

      if(!this.lsService.getLSItem('type') && this.request.ConnectionType != undefined){
        this.lsService.setLSItem('type', this.request.ConnectionType.toString())
      }
      else if(this.lsService.getLSItem('type') && this.request.ConnectionType != undefined){
        if(this.lsService.getLSItem('type') != this.request.ConnectionType.toString())
          this.lsService.setLSItem('type', this.request.ConnectionType.toString())
      }

      this.lsService.changueAgencyType(true);

      this.lstStatuses=await this.requestService.getRequestStatuses(id)
      this.updateNav()
      this.dataService.notifyAboutChange();
      await this.spinner.hide()
    } else {
      await this.spinner.hide()
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )

    }
    this.dataService.updateComponent(rq.RequestLocation[0].IdCountry);
  }
  async updateReq(id) {
    await this.spinner.show()
    this.idRequest = id;
    let rq = await this.requestService.getRequestById(id);
    if (rq != null) {
      this.request = rq;
      await this.checkEthicsCompliance(rq)
      this.lstStatuses=await this.requestService.getRequestStatuses(id)
      this.updateNav()
      this.dataService.notifyAboutChange();
      await this.dataService.updateComponent(rq.RequestLocation[0].IdCountry);
      await this.spinner.hide()
    } else {
      await this.spinner.hide()
      await Swal.fire({
        title: 'Error!',
        text: this.translate.instant('Request.Messages.ErrorSaving'),
        icon: 'error'
      }
      )

    }
    await this.updateNav()
    await this.dataService.updateComponent(rq.RequestLocation[0].IdCountry);
  }

  public async GetRequestByCode(requestcode){
    let id = ''
    if (requestcode != undefined){
      await this.documentService.getRequestByCode(requestcode)
        .then(async (res) =>{
          if(res != null){
            id = res.Id.toString()
          }      
          else {
            await Swal.fire({
              title: 'Error!',
              text: this.translate.instant('Request.Messages.ErrorSaving'),
              icon: 'error'
            }
            )
          }
        }
      )
    }
    return id
  }
 
  async ngAfterViewInit() {
    this.spinner.show();
    let idrequest = ""

    if(this.activeRoute.snapshot.params.requestcode != undefined){
      if(this.activeRoute.snapshot.params.requestcode.includes('AVD'))
        idrequest = await this.GetRequestByCode(this.activeRoute.snapshot.params.requestcode)
      else
        idrequest = this.activeRoute.snapshot.params.requestcode
    }
    else{
      idrequest = this.lsService.getLSItem("IdRequest") 
    }
    let lang = this.lang
    let type = this.lsService.getLSItem("type")
    let promises = []

    let rq = await this.requestService.getRequestById(idrequest == null ? "0" : idrequest);
    if (rq != null && rq.RequestLocation[0] != undefined) 
    {
      promises.push(this.loadDocumentTypesCrm(rq.RequestLocation[0].IdCountry))
    }

    promises.push(this.loadContactTypes())
    promises.push(this.loadRolesArd(rq != undefined ? rq.ConnectionType : type))
    promises.push(this.loadAgencyTypes())
    promises.push(this.loadCountries())
    promises.push(this.loadLanguages())
    await Promise.all(promises)
    if (idrequest != null) {
      await this.checkEthicsCompliance(rq)
      await this.updateRequest(idrequest);
    }
    else {
      let newRequest = new RequestModel()
      newRequest.Language = lang;
      if (type != null) {
        newRequest.ConnectionType = parseInt(type);

        if(newRequest.ConnectionType == environment.request.iataConnectionType 
          || newRequest.ConnectionType== environment.request.bspArcConnectionType
          || newRequest.ConnectionType == environment.request.syncConnectionType){
            if(this.lsService.getLSItem('agencyType') == AgencyTypes.IATAprimerIngreso.toString())
              newRequest.AgencyType = AgencyTypes.IATAprimerIngreso
            else if(this.lsService.getLSItem('agencyType') == AgencyTypes.CambioRepresentanteYAdmin.toString())
              newRequest.AgencyType = AgencyTypes.CambioRepresentanteYAdmin
            else
              newRequest.AgencyType = environment.request.iataAgencyType 
          }
        else{
          newRequest.AgencyType = environment.request.noIataAgencyType
        }
        
        this.request = newRequest;
      }
      else{
        this.spinner.hide();
       await Swal.fire({
          icon: 'warning',
          text: this.translate.instant('Request.Messages.ConnectionNotFound'),
          showConfirmButton: true
        })
       window.location.href = environment.request.redirect;
      }
    }
    if(this.request.IsUpdateCrm){

      if(this.request.UpdateCrmDone == undefined){
        this.updateIdentificationCrm = true;
        this.updateLegalCrm = true;
        this.updatePartnersCrm = true;
      }
      else if(this.request.UpdateCrmDone == 1){
        this.updateLegalCrm = true;
        this.updatePartnersCrm = true;
      }
      else if(this.request.UpdateCrmDone == 2){
        this.updateIdentificationCrm = true;
        this.updatePartnersCrm = true;
      }
      else if(this.request.UpdateCrmDone == 3){
        this.updateIdentificationCrm = true;
        this.updateLegalCrm = true;
      }
      else if(this.request.UpdateCrmDone == 4){
        this.updatePartnersCrm = true;
      }
      else if(this.request.UpdateCrmDone == 5){
        this.updateLegalCrm = true;
      }
      else if(this.request.UpdateCrmDone == 6){
        this.updateIdentificationCrm = true;
      }
    }
    this.updateNav();

    this.spinner.hide();
  }

  constructor(
    private readonly requestService: RequestService,
    private readonly spinner: NgxSpinnerService,
    private readonly activeRoute: ActivatedRoute,
    private readonly documentService: DocumentService,
    private readonly modalService: NgbModal,
    private readonly crmGeoService: crmGeoService,
    private readonly router: Router,
    private readonly translate: TranslateService,
    private readonly dataService: ComService,
    public ethicsComplianceService: EthicsComplianceService,
    private readonly lsService : SessionStorageService,
    private readonly formSectionService: FormSectionsService
  ) { }
 
  async redirectDocument() {
    //Validación automática de CRM

    if((this.request.IdFlow == 4 || this.request.IdFlow == 5 || this.request.IdFlow == 6 || this.request.IdFlow == 7 || this.request.IdFlow == 17 || this.request.IdFlow == 18) 
    && this.request.RequestStatus == null) {
      await this.spinner.show()
      await this.requestService.crmRequestValidation(this.request.Id).then(async (res) => {
        this.crmPreApproval = res;
      })
      await this.spinner.hide()
      if(this.crmPreApproval)
        this.router.navigate(['Register/Main/Document/' + this.request.RequestCode]);
      else{
        Swal.fire({
          html: this.popUp.nativeElement,
          width: 600,
          showCloseButton: true,
          confirmButtonText: this.translate.instant('Document.Label.Continue'),
          customClass: {
            confirmButton: 'btn btn-dark',
          },
          buttonsStyling: false
        }).then((res) => {
          window.location.replace(`Register/Main/Request`);
        })
      }
    }
    else{
      this.router.navigate(['Register/Main/Document/' + this.request.RequestCode]);
    }
  }

  openModalLearnFormData(){
    const modalRef = this.modalService.open(LearnmoreFormDataComponent, { size: 'xl' });
    modalRef.componentInstance.type = this.lsService.getLSItem('type');
  }

  //Cargar las secciones que se van a ver en el formulario según el flujo
  async updateNav() {
    
    if(this.request.IdFlow == undefined){
      //Crear las secciones del formulario
      let items: FillerNavItem[] = [];
      let overviewItem = new FillerNavItem();
      overviewItem.label = this.translate.instant('Request.Menu.Overview');
      overviewItem.icon = "info";
      overviewItem.link = 0;
      //Indica si la sección fue completada
      overviewItem.complete = this.request.completeOverview();
      //indica el estado de la sección
      overviewItem.message=this.lstStatuses.some(x=>x.IdComponent==2)

      let locationItem = new FillerNavItem();
      locationItem.label = this.translate.instant('Request.Menu.Location');
      locationItem.icon = "location_on"
      locationItem.link = 1
      locationItem.complete = this.request.completeLocation();
      locationItem.message=this.lstStatuses.some(x=>x.IdComponent==4)

      let identificacionItem = new FillerNavItem();
      identificacionItem.label = this.translate.instant('Request.Menu.Identification');
      identificacionItem.icon = "description"
      identificacionItem.link = 2
      identificacionItem.complete = this.request.completeIdentification();
      if(this.request.IsUpdateCrm){
        identificacionItem.update = this.updateIdentificationCrm
      } 
      identificacionItem.message=this.lstStatuses.some(x=>x.IdComponent==3)

      let legalItem = new FillerNavItem();
      legalItem.label = this.translate.instant('Request.Menu.Legal');
      legalItem.icon = "person"
      legalItem.link = 3
      legalItem.complete = this.request.completeLegal()
      if(this.request.IsUpdateCrm)
        legalItem.update = this.updateLegalCrm;
      legalItem.message=this.lstStatuses.some(x=>x.IdComponent==5)

      let contactsItem = new FillerNavItem();
      contactsItem.label = this.translate.instant('Request.Menu.Contacts');
      contactsItem.icon = "contact_page"
      contactsItem.link = 4
      contactsItem.complete = this.request.completeAdminPortal()
      contactsItem.message=this.lstStatuses.some(x=>x.IdComponent==6)

      let partnersItem = new FillerNavItem();
      partnersItem.label = this.translate.instant('Request.Menu.Partners');
      partnersItem.icon = "supervised_user_circle"
      partnersItem.link = 5
      partnersItem.complete = this.request.completePartners()
      if(this.request.IsUpdateCrm){
        partnersItem.update = this.updatePartnersCrm
      }
      partnersItem.message=this.lstStatuses.some(x=>x.IdComponent==7)

      let signaturesItem = new FillerNavItem();
      signaturesItem.label = this.translate.instant('Request.Menu.Signatures');
      signaturesItem.icon = "gesture"
      signaturesItem.link = 6
      signaturesItem.complete = this.request.completeSignatures()
      signaturesItem.message=this.lstStatuses.some(x=>x.IdComponent==8)

      let ethicsItem = new FillerNavItem();
      ethicsItem.label = this.translate.instant('Request.Menu.EthicsCompliance');
      ethicsItem.icon = "gesture"
      ethicsItem.link = 7
      ethicsItem.complete = this.validEthicsCompliance;

      let accessLetterItem = new FillerNavItem();
      accessLetterItem.label = this.translate.instant('Request.Menu.AccessLetter');
      accessLetterItem.icon = "gesture"
      accessLetterItem.link = 8
      accessLetterItem.complete = this.validAccessLetter;

      items.push(overviewItem);
      items.push(locationItem);
      items.push(identificacionItem);
      items.push(legalItem);
      items.push(contactsItem);
      items.push(partnersItem);
      this.itemCreate = items;
    }
    else{
      let items: FillerNavItem[] = [];
      let forms = await this.formSectionService.get(this.request.IdFlow)
      forms = forms.sort((a,b) => a.Order - b.Order)
      forms.forEach(section => {
        let newItem = new FillerNavItem();
        if(section.IdComponent == Sections.Generalidades){
          newItem.label = this.translate.instant('Request.Menu.Overview');
          newItem.icon = "info";
          newItem.link = 0;
          //Indica si la sección fue completada
          newItem.complete = this.request.completeOverview();
          //indica el estado de la sección
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.Generalidades)
        }
        else if(section.IdComponent == Sections.Localizacion){
          newItem.label = this.translate.instant('Request.Menu.Location');
          newItem.icon = "location_on"
          newItem.link = 1
          newItem.complete = this.request.completeLocation();
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.Localizacion)
        }
        else if(section.IdComponent == Sections.Identicacion){
          newItem.label = this.translate.instant('Request.Menu.Identification');
          newItem.icon = "description"
          newItem.link = 2
          newItem.complete = this.request.completeIdentification();
          if(this.request.IsUpdateCrm){
            newItem.update = this.updateIdentificationCrm
          } 
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.Identicacion)
        }
        else if(section.IdComponent == Sections.RepLegal){
          newItem.label = this.translate.instant('Request.Menu.Legal');
          newItem.icon = "person"
          newItem.link = 3
          newItem.complete = this.request.completeLegal()
          if(this.request.IsUpdateCrm)
            newItem.update = this.updateLegalCrm;
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.RepLegal)
        }
        else if(section.IdComponent == Sections.Accionistas){
          newItem.label = this.translate.instant('Request.Menu.Partners');
          newItem.icon = "supervised_user_circle"
          newItem.link = 5
          newItem.complete = this.request.completePartners()
          if(this.request.IsUpdateCrm){
            newItem.update = this.updatePartnersCrm
          }
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.Accionistas)
        }
        else if(section.IdComponent == Sections.AdminPortal){
          newItem.label = this.translate.instant('Request.Menu.Contacts');
          newItem.icon = "contact_page"
          newItem.link = 4
          newItem.complete = this.request.completeAdminPortal()
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.AdminPortal)
        }
        else if(section.IdComponent == Sections.Firmas){
          newItem.label = this.translate.instant('Request.Menu.Signatures');
          newItem.icon = "gesture"
          newItem.link = 6
          newItem.complete = this.request.completeSignatures()
          newItem.message=this.lstStatuses.some(x=>x.IdComponent==Sections.Firmas)
        }
        else if(section.IdComponent == Sections.AccesoInventario){
          newItem.label = this.translate.instant('Request.Menu.AccessLetter');
          newItem.icon = "gesture"
          newItem.link = 8
          newItem.complete = this.validAccessLetter;
        }
        else if(section.IdComponent == Sections.Etica){
          newItem.label = this.translate.instant('Request.Menu.EthicsCompliance');
          newItem.icon = "gesture"
          newItem.link = 7
          newItem.complete = this.validEthicsCompliance;
        }
        items.push(newItem);
      });
      this.itemCreate = items;
    }
    
    
    
  }

  updateIdentification(updated: boolean){
    this.updateIdentificationCrm = updated;
  }

  updateLegal(updated: boolean){
    this.updateLegalCrm = updated;
  }

  updatePartners(updated: boolean){
    this.updatePartnersCrm = updated;
  }
  //modulo firmas usuario del portal

  public async checkEthicsCompliance(rq): Promise<boolean>{
    this.request = rq

   let EntityTypeBool: boolean;
   let AviancaPoliciesBool: boolean;
   let PoliticsExposedBool: boolean;
   let ConflictInterestBool: boolean;
   let TermsCoditionsBool: boolean;
   let AccessLetterBool: boolean;

    if(this.request != undefined)
    {
      let oldIdBillingPeriod = this.request.IdBillingPeriod

      this.request.IdBillingPeriod = 2;
      await this.checkEntityTypeBool(this.request).then(res =>{
        EntityTypeBool = res
      });

      this.request.IdBillingPeriod = 3;
      await this.checkEntityTypeBool(this.request).then(res =>{
        AviancaPoliciesBool =  res
      });

      this.request.IdBillingPeriod = 4;
      PoliticsExposedBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 5;
      ConflictInterestBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 6;
      TermsCoditionsBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = 7;
      AccessLetterBool = await this.checkEntityTypeBool(this.request)

      this.request.IdBillingPeriod = oldIdBillingPeriod
    }

    let response
    if(EntityTypeBool && AviancaPoliciesBool && PoliticsExposedBool && ConflictInterestBool && TermsCoditionsBool)
    {
      
      this.validEthicsCompliance =  true;
    }
    else
    {
      
      this.validEthicsCompliance =  false;
    }

    if(AccessLetterBool)
    {
      this.validAccessLetter =  true;
    }
    else
    {
      this.validAccessLetter =  false;
    }
    return response
    
  }

  public async checkEntityTypeBool(section:RequestModel){
    let response:boolean
    if(!Number.isNaN(section.Id)){
      await this.ethicsComplianceService.getAnswersBySection(section).then(res =>{
        if(res.length != 0){
          response = true
        }else{
          response = false
        }
        return response;
      });
    }
    

    return response;
  }


   ngOnInit() {
    this.lang = this.activeLang
  }

  itemCreate: FillerNavItem[] = [
    { label: this.translate.instant('Request.Menu.Overview'),section: Sections.Generalidades, icon: "info", link: 0, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Identification'),section: Sections.Identicacion, icon: "description", link: 1, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Location'),section: Sections.Localizacion, icon: "location_on", link: 2, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Legal'),section: Sections.RepLegal, icon: "person", link: 3, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Contacts'),section: Sections.AdminPortal, icon: "contact_page", link: 4, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Partners'),section: Sections.Accionistas, icon: "supervised_user_circle", link: 5, complete: false , rejected: false,message:false ,Review: false, update: false},
    { label: this.translate.instant('Request.Menu.Signatures'),section: Sections.Firmas, icon: "gesture", link: 6, complete: false , rejected: false,message:false ,Review: false, update: false}
  ]


  clickNav(id: number) {
    //A partir de un id de un paso, cree una sublista a partir de la lista original itemCreate
    //y que verifique si el paso anterior fue completado
    const subList = this.itemCreate.slice(0, this.itemCreate.findIndex(x => x.link == id));
    const allPreviousStepsComplete = subList.every(item => item.complete);
    
    if(allPreviousStepsComplete){
      this.setStep(id)
    }
    if(!allPreviousStepsComplete)
    {
      Swal.fire({
        icon: 'warning',
        text: this.translate.instant('Request.Messages.Requirements'),
        showConfirmButton: false,
        timer: 2000
      })
    }  
  }

  FormIsincomplete(): boolean{
    let formIncomplete = false
    this.itemCreate.forEach(item => {
      if(item.complete == false){
        formIncomplete = true
      }
    });
    return formIncomplete
  }
}

